/**
 * Time formatting utilities shared across AddClassModal and AddTrainingModal
 */

// Time options in 30-minute intervals (12:00 AM - 11:30 PM)
export const TIME_OPTIONS = [
  '12:00 AM', '12:30 AM',
  '1:00 AM', '1:30 AM',
  '2:00 AM', '2:30 AM',
  '3:00 AM', '3:30 AM',
  '4:00 AM', '4:30 AM',
  '5:00 AM', '5:30 AM',
  '6:00 AM', '6:30 AM',
  '7:00 AM', '7:30 AM',
  '8:00 AM', '8:30 AM',
  '9:00 AM', '9:30 AM',
  '10:00 AM', '10:30 AM',
  '11:00 AM', '11:30 AM',
  '12:00 PM', '12:30 PM',
  '1:00 PM', '1:30 PM',
  '2:00 PM', '2:30 PM',
  '3:00 PM', '3:30 PM',
  '4:00 PM', '4:30 PM',
  '5:00 PM', '5:30 PM',
  '6:00 PM', '6:30 PM',
  '7:00 PM', '7:30 PM',
  '8:00 PM', '8:30 PM',
  '9:00 PM', '9:30 PM',
  '10:00 PM', '10:30 PM',
  '11:00 PM', '11:30 PM'
];

/**
 * Format time input to AM/PM format
 * Handles both 24-hour and AM/PM inputs
 */
export const formatTimeToAMPM = (timeInput: string): string | null => {
  if (!timeInput) return null;

  // If already in AM/PM format, return as is
  if (timeInput.includes('AM') || timeInput.includes('PM')) {
    return timeInput;
  }

  // Try to parse as 24-hour format
  const timeRegex = /^(\d{1,2}):(\d{2})$/;
  const match = timeInput.match(timeRegex);

  if (match) {
    const hours = parseInt(match[1]);
    const minutes = parseInt(match[2]);

    if (hours >= 0 && hours <= 23 && minutes >= 0 && minutes <= 59) {
      const period = hours >= 12 ? 'PM' : 'AM';
      const displayHours = hours === 0 ? 12 : hours > 12 ? hours - 12 : hours;
      return `${displayHours}:${minutes.toString().padStart(2, '0')} ${period}`;
    }
  }

  return null;
};

/**
 * Convert AM/PM time to 24-hour format (HH:MM)
 * Handles both 24-hour and AM/PM inputs
 */
export const convertTimeTo24Hour = (timeInput: string): string => {
  if (!timeInput) return '';

  // Remove any extra spaces
  const time = timeInput.trim();

  // Check if already in 24-hour format
  const hour24Regex = /^(\d{1,2}):(\d{2})$/;
  const hour24Match = time.match(hour24Regex);
  if (hour24Match) {
    const hours = parseInt(hour24Match[1]);
    const minutes = hour24Match[2];
    if (hours >= 0 && hours <= 23) {
      return `${hours.toString().padStart(2, '0')}:${minutes}`;
    }
  }

  // Parse AM/PM format
  const ampmRegex = /^(\d{1,2}):(\d{2})\s*(AM|PM)$/i;
  const ampmMatch = time.match(ampmRegex);

  if (ampmMatch) {
    let hours = parseInt(ampmMatch[1]);
    const minutes = ampmMatch[2];
    const period = ampmMatch[3].toUpperCase();

    if (period === 'PM' && hours !== 12) {
      hours += 12;
    } else if (period === 'AM' && hours === 12) {
      hours = 0;
    }

    return `${hours.toString().padStart(2, '0')}:${minutes}`;
  }

  return '';
};
